import {injectable} from "inversify";
import {ShopService} from "@/services/shop-service";
import {TabbedPanel} from "@/scenes.ui/tabbed-panel";
import {Tr} from "@/i18n/i18n";
import {Player} from "@/store/player/types";
import {ShopArtifactContext} from "@/store/shop/types";

@injectable()
export class ArtifactTownShopService extends ShopService {

    protected createTabbedPanel(): TabbedPanel {
        let self = this;
        return new TabbedPanel(this.scene!, this.canvas!, Tr('amulet.shop'), ['bank', 'artifacts'],
            [Tr('bank'), Tr('amulets')], [true, true], this.selectSound, (tabId: string) => {
                if (tabId === 'bank') {
                    this.populateBankTab();
                } else if (tabId === 'artifacts') {
                    this.doPopulateArtifactTab(ShopArtifactContext.ARTIFACT_TOWN);
                }
            }, () => {}, () => self.closeCallback());
    }

    protected setupHeroAgitations(player: Player) {
        this.tabbedPanel.setAgitationText(Tr('am.comm'));
    }
}
